(function() { window.GUID_13ddddfe_377f_4571_bcbd_6386ab3426f1 = { getGuid: function() { return "13ddddfe-377f-4571-bcbd-6386ab3426f1"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Accordion extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.customNumberA = null;
                this.beforeCollapseCallback = null;
                this.demoMode = false;
                this.preventExpandCollapseOnce = false;
            }
            get FixedHeaderHelper() {
                return this.fixedHeaderHelper;
            }
            get IsExpanded() {
                var _a, _b;
                return (_b = (_a = this.Data) === null || _a === void 0 ? void 0 : _a.IsExpanded) !== null && _b !== void 0 ? _b : false;
            }
            get ControlId() {
                return this.$Container.attr("id");
            }
            get $Control() {
                return this.$Container;
            }
            get RefreshContentOnClosed() {
                var _a;
                return ((_a = this.Data) === null || _a === void 0 ? void 0 : _a.RefreshContentOnClosed) == true;
            }
            get ajaxRefreshable() {
                var _a;
                if ((_a = this.Data) === null || _a === void 0 ? void 0 : _a.RefreshUrl)
                    return true;
                else
                    return false;
            }
            get title() {
                var _a;
                return (_a = this.$Header
                    .find(".main-wall-section-header__title")
                    .text()) === null || _a === void 0 ? void 0 : _a.trim();
            }
            PreventExpendCollapseOnce() {
                this.preventExpandCollapseOnce = true;
            }
            OnControlInstantiation(params) {
                let me = this;
                me.headerId = params[1];
                me.ContentId = params[0];
                me.$Header = $("#" + me.headerId);
                me.wrapHeaderContent();
                me.$Content = $("#" + me.ContentId);
                if (me.$Content.closest(".popup-content").length > 0) {
                    me.inPopupOrDrawer = true;
                }
                if (me.$Content.length == 0) {
                    //throw new Error(errorMessage);
                    const errorMessage = `The DIV content need to be return event if the accordion is collapsed. Accordion ID: ${me.ContentId}`;
                    console.error(errorMessage);
                    return;
                }
                if (params[2] != null && params[2].trim() != "") {
                    me.$Trigger = $("#" + params[2]);
                }
                else {
                    me.$Trigger = me.$Header;
                }
                me.$Trigger.addClass("accordion-trigger");
                me.$Header.addClass("accordion-header");
                me.$Content.addClass("accordion-content");
                me.demoMode = me.$Content.attr("data-demo-mode") == "true";
                me.$Container = $('<div class="accordion-container"></div>');
                if (params.length > 2 && params[3]) {
                    me.$Container.addClass(params[3]);
                }
                me.$Container.attr("id", me.ContentId + "-container");
                me.$Container.insertAfter(me.$Content);
                me.$Container.append(me.$Header);
                me.$Container.append(me.$Content);
                if (me.$Header.hasClass("header-overrided")) {
                    me.$Container.addClass("container-overrided");
                    //let $parent = me.$Container.parent('.accordion-content');
                    //$parent.addClass('container-overrided');
                }
                me.refreshDataFromHidden();
                me.refreshUIBasedOnData();
                me.refreshNoContentMessageVisibility();
                //me.appendItemsCountElement();
                me.appendOptions();
                CS.DOM.AssignInstanceToJQueryElement(me, me.$Content);
                CS.DOM.AssignInstanceToJQueryElement(me, me.$Container);
                me.triggerReadyEvent();
                me.activateFixedHeader();
                me.$Container.offon("lazyload." + me.ControlId, function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    me.onLazyLoaderTriggered(e);
                });
                Controls.LazyLoadHelper.Activate();
                CS.DOM.$win.offon(`resize.accordion-${this.ContentId}`, () => {
                    CS.Lag(`resizeaccordion${this.ContentId}`, 150, () => {
                        me.Trigger(Accordion.EventNames.Resized);
                    });
                });
            }
            OnControlRendered() {
                const me = this;
                me.Trigger(Accordion.EventNames.Rendered);
            }
            GetTopHeight(includeCurrentHeader = false) {
                const me = this;
                let height = 0;
                let $sectionTop = $(".section-top").last();
                if (!me.inPopupOrDrawer) {
                    // Nécessaire puisque "inner-sub-top" n'est plus nesté dans "section-top"
                    const $sectionInnerSubTop = $(".section-inner-subtop").last();
                    if ($sectionInnerSubTop.length > 0) {
                        height += Math.floor($sectionInnerSubTop.outerHeight());
                        const $searchbar = $sectionInnerSubTop.find(".app__search-bar");
                        if ($searchbar.length > 0) {
                            // Parce que le search bar se cache quand on scroll vers le bas, donc faut pas la calculer
                            height -= $searchbar.outerHeight();
                        }
                    }
                    //const $secondaryTopbarHeight = $sectionTop.find(".secondary-topbar");
                    //if ($secondaryTopbarHeight.length) {
                    //    height += Math.floor($secondaryTopbarHeight.outerHeight()) - 1;
                    //}
                    if ($("#event-wall").length && CS.Views.EventWallView != null) {
                        height += CS.Views.EventWallView.GetSubtopEventDropdownHeight() - 1;
                    }
                }
                if (me.inPopupOrDrawer) {
                    let $stickyParent = me.$Container.parents(".accordion-container");
                    if ($stickyParent.length > 0) {
                        $.each($stickyParent, (e, element) => {
                            let $this = $(element);
                            let $header = $this.children(".accordion-header");
                            if ($header.is(":visible")) {
                                height += Math.floor($header.outerHeight());
                            }
                        });
                    }
                }
                else if ($sectionTop.length > 0) {
                    let $stickyParent = me.$Container.parents(".accordion-container");
                    height += Math.floor($sectionTop.outerHeight());
                    if ($stickyParent.length > 0) {
                        $.each($stickyParent, (e, element) => {
                            let $this = $(element);
                            let $header = $this.children(".accordion-header");
                            if ($header.is(":visible")) {
                                height += Math.floor($header.outerHeight());
                            }
                        });
                    }
                }
                if (includeCurrentHeader) {
                    height += Math.floor(me.$Header.outerHeight());
                }
                return height;
            }
            getHeaderHeight() {
                const me = this;
                let height = 0;
                if (me.$Header.length > 0) {
                    height += me.$Header.height();
                }
                return height;
            }
            activateFixedHeader() {
                let me = this;
                $(() => {
                    if (me.IsExpanded) {
                        me.refreshFixedHeaderHeights();
                    }
                });
            }
            refreshFixedHeaderHeights(extraTop) {
                let me = this;
                if (me.Data && me.Data.FixedHeaderEnabled) {
                    let sectionTopHeight = me.GetTopHeight();
                    if (!isNaN(sectionTopHeight)) {
                        let $sectionTop = $(".section-top").last();
                        if (extraTop != null) {
                            sectionTopHeight += extraTop;
                        }
                        if ($sectionTop.length > 0) {
                            me.$Header.css({
                                top: sectionTopHeight - 0.5,
                            });
                            me.$Header.addClass("sticky");
                        }
                    }
                }
            }
            onLazyLoaderTriggered(e) {
                let me = this;
                let $trigger = $(e.target);
                let skipQuantity = $trigger.data("skipquantity");
                let $container = $trigger.parent();
                if (me.IsExpanded) {
                    CS.Ajax.Post(me.Data.RefreshUrl, me.getLazyStringifiedData(skipQuantity), function (response) {
                        let $response = $(response);
                        let $buttonGoTo = $container.find(".button-go-to");
                        if ($response.hasClass("gridview")) {
                            let gridView = CS.Controls.GetInstance(CS.Controls.GridView, $container.find(".gridview"));
                            gridView.AppendNewGridContent($response);
                            let $lazyLoadButton = $response.filter(".lazy-loader-trigger");
                            if ($lazyLoadButton.length > 0) {
                                $container.append($lazyLoadButton);
                            }
                        }
                        else {
                            if ($buttonGoTo.length > 0) {
                                const $buttonParent = $buttonGoTo.parent();
                                if (!$buttonParent.hasClass("accordion-content"))
                                    $response.insertBefore($buttonParent);
                                else
                                    $response.insertBefore($buttonGoTo);
                            }
                            else {
                                $container.append($response);
                            }
                        }
                        e.target.remove();
                        me.Trigger(Accordion.EventNames.ContentLoaded);
                        Controls.LazyLoadHelper.Activate();
                    });
                }
            }
            /**
             *
             * @param $content
             * @param $subHeaderStickyContent Si on a un élément sticky en-dessous du header, doit ajuster la hauteur du top et le z-index des pour que les éléments suivants passent en-dessous. Éventuellement, ça devrait être géré par l'accordéon lui-même.
             */
            SetContentSticky($content, $subHeaderStickyContent = null) {
                const me = this;
                if (this.$Header.hasClass("no-sticky-header"))
                    return;
                CS.DOM.$win.one("scroll", () => {
                    const $innerContent = me.$Content.find($content);
                    if ($innerContent.length > 0) {
                        if (!$innerContent.hasClass("sticky")) {
                            let y = me.GetTopHeight();
                            y += me.getHeaderHeight();
                            // Pour pas voir le contenu passer derrière le header
                            y--;
                            $innerContent.addClass("sticky");
                            if ($subHeaderStickyContent != null &&
                                $subHeaderStickyContent.length > 0) {
                                const subHeaderHeight = $subHeaderStickyContent.outerHeight();
                                let _zIndex = $subHeaderStickyContent.css("z-index");
                                const zIndex = parseInt(_zIndex);
                                if (!isNaN(zIndex)) {
                                    $innerContent.css({
                                        "z-index": zIndex - 1,
                                    });
                                }
                                y += subHeaderHeight;
                                // Pour pas voir le contenu passer derrière le subHeader
                                y--;
                            }
                            if ($(".stats-compare-wall__header").length) {
                                const $filterChips = $(".filter-chips");
                                if ($filterChips.length) {
                                    y += $filterChips.first().outerHeight();
                                }
                            }
                            $innerContent.css({
                                top: y,
                            });
                        }
                    }
                });
            }
            OnBindEvents() {
                let me = this;
                if (me.$Trigger != undefined) {
                    me.$Trigger.offon("click." + me.ControlId, function (e) {
                        if (me.$Container.hasClass("prevent-expend-collapse-trigger-on-header-click")) {
                            return;
                        }
                        me.Trigger(Accordion.EventNames.ExpandingCollapsing, {
                            data: me.Data,
                            jqueryEventObject: e,
                        });
                        me.ExpandCollapse();
                    });
                }
                CS.DOM.$body.offon(`click.wallSectionDropdownClicked${me.ContentId}`, `#dropdown-wall-section-options-dropdown-${this.ContentId} .list-item`, (e) => {
                    const $item = $(e.currentTarget);
                    const $picker = $(`div[data-pickerof="dropdown-wall-section-options-dropdown-${this.ContentId}"]`);
                    let parentAccordion = CS.Controls.GetInstance(Accordion, $picker.closest(".accordion-container"));
                    let extraParam;
                    extraParam = {
                        data: {
                            extraValues: $item.data("extravalues"),
                            parentAccordion,
                        },
                        jqueryEventObject: e,
                    };
                    const { action, url } = $item.data("extravalues");
                    parentAccordion.Trigger(Accordion.EventNames.OptionClicked, extraParam);
                    CS.Analytics.Event("Accordion", "OptionClicked", me.title);
                    let callUrlOnClick = action != null;
                    if (callUrlOnClick) {
                        if (url && !$item.hasClass("locked")) {
                            CS.Ajax.Post(url + me.Data.ExtraQueryString, parentAccordion.getStringifiedData(false), function (response) {
                                parentAccordion.Trigger(Accordion.EventNames.OptionClicked, response);
                                CS.Analytics.Event("Accordion", "OptionClicked", me.title);
                            });
                        }
                        if (action == "pin") {
                            CS.Helper.log("Accordion", `Pin clicked on ${me.title}`);
                            CS.Analytics.Event("Pin", parentAccordion.title, `${CS.CommonData.Current.Navigation.Controller}/${CS.CommonData.Current.Navigation.Action}`);
                        }
                    }
                });
                //Controls.DropDown.Events.ListItemClicked({
                //    selector: DOM.$body,
                //    childSelector: `#dropdown-wall-section-options-dropdown-${this.ContentId}`,
                //    callback: (list, e) => {
                //        console.log(this.ContentId);
                //        const $picker = $(`div[data-pickerof="dropdown-wall-section-options-dropdown-${this.ContentId}"]`);
                //        console.log($picker);
                //        //let parentAccordion = CS.Controls.GetInstance(Accordion, picker.$Control.closest('.accordion-container'));
                //        //let extraParam: IExtraParams<any>;
                //        //extraParam = {
                //        //    data: e.data,
                //        //    jqueryEventObject: e.jqueryEventObject
                //        //};
                //        //extraParam.data.parentAccordion = parentAccordion;
                //        //const { action } = e.data.extraValues;
                //        //parentAccordion.Trigger(Accordion.EventNames.OptionClicked, extraParam);
                //        //CS.Analytics.Event('Accordion', 'OptionClicked', me.title);
                //        //let callUrlOnClick = action != null;
                //        //if (callUrlOnClick) {
                //        //    let url = e.data.extraValues.url + me.Data.ExtraQueryString;
                //        //    if (url) {
                //        //        CS.Ajax.Post(url, parentAccordion.getStringifiedData(false), function (response) {
                //        //            parentAccordion.Trigger(Accordion.EventNames.OptionClicked, response);
                //        //            CS.Analytics.Event('Accordion', 'OptionClicked', me.title);
                //        //        });
                //        //    }
                //        //    if (action == "pin") {
                //        //        console.log(`%c me.title = ${me.title}`, `color: #bada55`);
                //        //        console.log(`%c parentAccordion.title = ${parentAccordion.title}`, `color: #bada55`);
                //        //        CS.Analytics.Event("Pin", parentAccordion.title, `${CommonData.Current.Navigation.Controller}/${CommonData.Current.Navigation.Action}`);
                //        //    }
                //        //}
                //    }
                //});
            }
            OnDispose() {
                this.$Trigger.off("click." + this.ControlId);
                this.$Header.off("click.options-" + this.ControlId, ".options");
                this.disposeChilds();
                let me = this;
                this.$Container.slideUp(150, function () {
                    me.$Container.remove();
                });
                this.$Control.remove();
            }
            ExpandCollapse(expand = null, showContentCallback = null, callback = null) {
                var _a;
                let me = this;
                if (!me.preventExpandCollapseOnce) {
                    if (me.$Header.hasClass("body-element"))
                        return;
                    if (me.$Container.hasClass("prevent-collapsing")) {
                        if (expand != true) {
                            return;
                        }
                    }
                    if (me.$Header.hasClass("pin-locked")) {
                        const msg = me.$Header.data("snackbar-msg");
                        if (msg != null) {
                            Controls.Snackbar.Show({
                                Id: "pin-locked-snackbar",
                                Message: msg,
                                Type: CS.Enumeration.SnackbarType.Info,
                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                AutoHideDuration: 3000,
                            });
                        }
                        return;
                    }
                    if ((_a = me.Data) === null || _a === void 0 ? void 0 : _a.IsExpanded) {
                        // Collapsing
                        if (me.beforeCollapseCallback != null) {
                            me.beforeCollapseCallback()
                                .then(() => {
                                me.collapse(expand, showContentCallback);
                                if (callback)
                                    callback();
                            })
                                .catch((e) => {
                                console.error(e);
                                me.collapse(expand, showContentCallback);
                                if (callback)
                                    callback();
                            });
                        }
                        else {
                            me.collapse(expand, showContentCallback);
                            if (callback)
                                callback();
                        }
                    }
                    else {
                        // Expanding
                        me.expand(null, showContentCallback);
                        if (callback)
                            callback();
                    }
                }
                else {
                    me.preventExpandCollapseOnce = false;
                }
            }
            setExpandingState() {
                this.$Container.addClass("is-expanding");
                CS.Helper.ShowLoader({
                    id: this.ContentId,
                    $container: () => this.$Container,
                    position: "append",
                    autoRemoveDelay: null,
                    overContent: false,
                });
            }
            unsetExpandingState() {
                this.$Container.removeClass("is-expanding");
                CS.Helper.RemoveLoader({
                    id: this.ContentId,
                    $container: this.$Container,
                });
            }
            expand(expand = null, showContentCallback = null) {
                if (expand == false)
                    return;
                this.Data.IsExpanded = true;
                this.saveStateAndRefreshContentIfNeeded(() => {
                    this.showContent(showContentCallback);
                });
                CS.Analytics.Event("Accordion", "Expand", this.title);
            }
            collapse(expand = null, showContentCallback = null) {
                if (expand == true) {
                    showContentCallback();
                    return;
                }
                this.Data.IsExpanded = false;
                this.saveStateAndRefreshContentIfNeeded(() => {
                    this.hideContent();
                });
                CS.Analytics.Event("Accordion", "Collapse", this.title);
            }
            accordionIsScrolledUnderTopbar() {
                let topbarHeight = 0;
                let subTopbarHeight = 0;
                if (CS.DOM.$lastTopbar().length)
                    topbarHeight = CS.DOM.$lastTopbar().outerHeight();
                if (CS.DOM.$lastSubTopbar().length)
                    subTopbarHeight = CS.DOM.$lastSubTopbar().outerHeight();
                const topHeight = topbarHeight + subTopbarHeight;
                const accordionTop = this.$Container[0].getBoundingClientRect().top;
                const accordionIsScrolled = accordionTop < topHeight;
                return accordionIsScrolled;
            }
            scrollToAccordionHeader(duration, callback) {
                const nestedInAccordion = this.$Control
                    .parent()
                    .closest(".accordion-container").length;
                const nestedInPopup = this.$Control.closest(".popup").length;
                if (!nestedInAccordion && !nestedInPopup) {
                    /*
                     * On ne veut pas scroller si l'accordéon qu'on vient de collapser
                     * est imbriqué dans une popup ou un autre accordéon.
                     *
                     * Pour faire en sorte que ça fonctionne dans un accordéon, il
                     * faudrait prendre en compte la hauteur de tous les headers des
                     * accordéons parents qui sont activement "sticky"
                     */
                    const y = Math.floor(this.$Container.offset().top);
                    let offset = 0;
                    const $lastTopar = CS.DOM.$lastTopbar();
                    const $lastSubTopbar = CS.DOM.$lastSubTopbar();
                    if ($lastTopar.length)
                        offset += Math.floor($lastTopar.outerHeight());
                    if ($lastSubTopbar.length)
                        offset += Math.floor($lastSubTopbar.outerHeight());
                    //window.scrollTo({ top: y - offset, behavior: "smooth" });
                    CS.DOM.$body.addClass("prevent-scrolling");
                    $([document.documentElement, document.body]).animate({
                        scrollTop: y - offset,
                    }, duration, () => {
                        CS.DOM.$body.removeClass("prevent-scrolling");
                        if (callback != null)
                            callback.call(this);
                    });
                }
            }
            RefreshContent(callback = null, overrideRefreshUrl = null) {
                let me = this;
                me.Data.IsExpanded = true;
                if (overrideRefreshUrl != null)
                    this.Data.RefreshUrl = overrideRefreshUrl;
                me.saveStateAndRefreshContentIfNeeded(() => {
                    me.showContent(callback);
                });
            }
            saveStateAndRefreshContentIfNeeded(callback) {
                let me = this;
                CS.Helper.log("Accordion", "Saving state and refreshing content...");
                if (this.ajaxRefreshable && this.Data) {
                    const url = this.Data.RefreshUrl + this.Data.ExtraQueryString;
                    CS.Ajax.Post(url, me.getStringifiedData(), (response) => {
                        if (me.Data.IsExpanded || me.RefreshContentOnClosed) {
                            me.refreshedContent(response);
                        }
                        else {
                            CS.Helper.log("Accordion", "Content fetched, but not refreshed.");
                        }
                        callback();
                    });
                }
                else {
                    CS.Helper.log("Accordion", "No need to refresh content.");
                    callback();
                }
            }
            hideContent() {
                let me = this;
                if (this.ajaxRefreshable) {
                    this.disposeChilds();
                }
                const duration = 250;
                if (this.accordionIsScrolledUnderTopbar())
                    this.scrollToAccordionHeader(duration, null);
                // +50 parce que sinon le "scrollTop" dans "scrollToAccordionHeader()" glitch
                this.$Content.slideUp(duration + 50, () => {
                    this.replaceContentHtml();
                    me.refreshUIBasedOnData();
                    me.Trigger(Accordion.EventNames.ExpandedCollapsed);
                    Controls.LazyLoadHelper.Activate();
                });
            }
            showContent(showContentCallback = null) {
                let me = this;
                if (me.fixedHeaderHelper) {
                    me.fixedHeaderHelper.ResetLazyLoading();
                }
                me.refreshFixedHeaderHeights();
                me.$Content.slideDown(250, () => {
                    me.refreshUIBasedOnData();
                    me.Trigger(Accordion.EventNames.ExpandedCollapsed);
                    if (showContentCallback) {
                        showContentCallback();
                    }
                });
            }
            refreshedContent(response) {
                CS.Helper.log("Accordion", "Accordion: Refreshing content...");
                const isCollapsing = !this.IsExpanded;
                //Le wraping du div fait sur que si plusieurs element sont retourné dans response, que le find plus bas va fonctionner. Sinon
                //on serait obligé de prendre filter et parfois find selon le cas.
                let $response = $("<div>" + response + "</div>");
                this.refreshDataFromHidden($response);
                var containHeader = false;
                //let $newHeader = $response.find('#' + this.headerId);
                let $newHeader = $response.find(".accordion-header:first");
                if ($newHeader.length > 0) {
                    this.$Header[0].innerHTML = $newHeader[0].innerHTML;
                    this.wrapHeaderContent();
                    //this.appendItemsCountElement();
                    this.appendOptions();
                    containHeader = true;
                }
                //let $content = $response.find('#' + this.contentId);
                let $content = $response.find(".accordion-content:first");
                if ($content.length > 0) {
                    this.contentNewInnerHtml = $content[0].innerHTML.trim();
                    if (!isCollapsing) {
                        CS.Helper.log("Accordion", "Replacing HTML content...");
                        this.replaceContentHtml();
                    }
                    else {
                        // Le contenu est remplacé dans "hideContent" après le "slideUp" pour pas faire glitcher l'animation
                    }
                }
                this.Trigger(Accordion.EventNames.ContentRefreshed);
                this.Trigger(Accordion.EventNames.ContentLoaded);
                this.triggerReadyEvent();
                this.refreshNoContentMessageVisibility();
            }
            triggerReadyEvent() {
                this.Trigger(Accordion.EventNames.Ready);
                let isRefreshing = false;
                const toggleSparesCheckboxId = `checkbox-IncludeSparesToggle-${this.ContentId}`.toLowerCase();
                Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: this.$Container,
                    childSelector: `#${toggleSparesCheckboxId}`,
                    callback: (checkbox, e) => {
                        var _a;
                        const url = (_a = e.data.extraData.url) !== null && _a !== void 0 ? _a : "";
                        if (!CS.Helper.isNullOrWhiteSpace(url) && !isRefreshing) {
                            isRefreshing = true;
                            this.RefreshContent(() => {
                                isRefreshing = false;
                            }, url);
                        }
                    },
                });
                const toggleCsrDisplayCheckboxId = `checkbox-ToggleCsrUrl-${this.ContentId}`.toLowerCase();
                Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: this.$Container,
                    childSelector: `#${toggleCsrDisplayCheckboxId}`,
                    callback: (checkbox, e) => {
                        const { url, uncheckedTitle, checkedTitle } = e.data.extraData;
                        if (url && !CS.Helper.isNullOrWhiteSpace(url) && !isRefreshing) {
                            isRefreshing = true;
                            if (checkedTitle && uncheckedTitle) {
                                const $titleElement = this.$Header.find(".main-wall-section-header__title");
                                if ($titleElement.length > 0) {
                                    $titleElement.text(checkbox.IsChecked ? checkedTitle : uncheckedTitle);
                                }
                            }
                            this.RefreshContent(() => {
                                isRefreshing = false;
                            }, url);
                        }
                    },
                });
            }
            replaceContentHtml() {
                if (this.contentNewInnerHtml != null) {
                    this.$Content[0].innerHTML = this.contentNewInnerHtml;
                    this.contentNewInnerHtml = null;
                    CS.Helper.log("Accordion", "Content replaced.");
                }
                else {
                    CS.Helper.log("Accordion", "No content to replace.");
                }
            }
            refreshDataFromHidden($context = null) {
                let $hidden;
                if ($context) {
                    $hidden = $context.find("#" + this.$Header.attr("id") + "-data");
                }
                else {
                    $hidden = $("#" + this.$Header.attr("id") + "-data");
                }
                if ($hidden.length > 0) {
                    this.Data = $hidden.data("html");
                    $hidden.remove();
                }
            }
            refreshUIBasedOnData() {
                var _a;
                let me = this;
                if (!me.Data) {
                    return;
                }
                if (((_a = me.Data) === null || _a === void 0 ? void 0 : _a.IsExpanded) && !me.Data.PinLocked) {
                    me.$Trigger.addClass("is-expanded");
                    me.$Header.addClass("is-expanded");
                    me.$Content.addClass("is-expanded");
                }
                else {
                    me.$Trigger.removeClass("is-expanded");
                    me.$Header.removeClass("is-expanded");
                    me.$Content.removeClass("is-expanded");
                }
                //J'aurais aimé mieux ne pas faire ca mais temporairement
                //cest plus simple de faire un refresh du dropdown sur le refresh
                //de l'accordion mais dans un monde idéal, il ne faudrait pas
                //qu'il y ai de correspondance entre les 2 controls
                CS.Lag("refresh-dropdown-parent", 250, function () {
                    let dropDownParent = me.$Container.closest(".dropdown");
                    if (dropDownParent.length > 0) {
                        let dropdownInstance = CS.Controls.GetInstance(Controls.DropDown, dropDownParent);
                        dropdownInstance.RefreshDropDownLayout();
                    }
                });
            }
            //public appendItemsCountElement() {
            //    let count = "";
            //    if (this.Data.ItemsCount != null && this.$Header && this.Data.ItemsCount > 0) {
            //        count = "(" + this.Data.ItemsCount.toString() + ")";
            //    }
            //    //Je lappend tout le temps meme si pas de valeur parce que sinon , ca fait un desenlignement entre les differentes sections
            //    this.$itemsCount = $("<div class='items-count'>" + count + "</div>");
            //    this.$Header.append(this.$itemsCount);
            //}
            appendOptions() {
                let me = this;
                let $pinContainer = this.$Header.find(".pin-container");
                let $headerContent = this.$Header.find(".main-wall-section-header-content");
                $pinContainer.offon("click.pincontainer", function (e) {
                    e.stopImmediatePropagation();
                    let $container = $(e.target).closest(".pin-container");
                    if ($container.hasClass("is-premium-locked")) {
                        let teaserUrl = $container.data("teaserurl");
                        Controls.Popup.ShowAjaxModal(teaserUrl, null, (p) => {
                            // Popup loaded
                        }, (p) => {
                            // Popup closed
                        }, true, true);
                        return;
                    }
                    let pinned = $headerContent.hasClass("pinned");
                    let url = $container.data("url") + me.Data.ExtraQueryString;
                    if (url) {
                        CS.Ajax.Post(url, me.getStringifiedData(false), function (response) {
                            if (response.Success) {
                                $headerContent.toggleClass("pinned", !pinned);
                                me.Data.PinnedSectionId = response.PinnedSectionId;
                                const msg = $container.data("successmsg");
                                if (!CS.Helper.isNullOrWhiteSpace(msg)) {
                                    Controls.Snackbar.Show({
                                        Id: "pin-toggle-success",
                                        Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                        Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                        Type: $container.hasClass("unpin")
                                            ? CS.Enumeration.SnackbarType.Info
                                            : CS.Enumeration.SnackbarType.Success,
                                        Message: msg,
                                        AutoHideDuration: 3000,
                                    });
                                }
                                $(".pin").toggleClass("is-premium-locked", !response.CanPin);
                            }
                            else {
                                Controls.Snackbar.Show({
                                    Id: "pin-toggle-error",
                                    Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                    Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                    Type: CS.Enumeration.SnackbarType.Danger,
                                    AutoHideDuration: 3000,
                                    Message: CS.Lang("An error has occurred, please try again later.", "Une erreure s'est produite, veuillez réessayer plus tard.", "Ha ocurrido un error, inténtalo de nuevo más tarde."),
                                });
                            }
                        });
                    }
                    if (!pinned) {
                        CS.Analytics.Event("Pin", this.title, `${CS.CommonData.Current.Navigation.Controller}/${CS.CommonData.Current.Navigation.Action}`);
                    }
                });
                //if (this.Data.AccordionDropDownOptions && this.Data.AccordionDropDownOptions.ShowSectionDropdownOptionsUrl) {
                //    if (!this.$Header.hasClass("main-wall-section-header")) {
                //        this.$Header.append("<div id='options-of-" + this.ControlId + "' class='options'></div>");
                //    }
                //    let $options = this.$Header.find('.options');
                //    console
                //    let dropDown = CS.Controls.GetInstance(DropDown, '#dropdown-wall-section-options-dropdown-' + this.UniqueInstanceId, true);
                //    if (dropDown) {
                //        this.optionsPicker = new CS.Controls.DropDownPicker(dropDown, $options);
                //        //CS.Controls.DropDownPicker.Events.Clicked({
                //        //    selector: $options,
                //        //    callback: (picker, e) => {
                //        //        console.log(dropDown.$Control);
                //        //    }
                //        //});
                //        CS.Controls.DropDownPicker.Events.ListItemClicked({
                //            selector: dropDown,
                //            callback: (c, e) => {
                //                let picker = dropDown.CurrentPicker;
                //                let parentAccordion = CS.Controls.GetInstance(Accordion, picker.$Control.closest('.accordion-container'));
                //                let extraParam: IExtraParams<any>;
                //                extraParam = {
                //                    data: e.data,
                //                    jqueryEventObject: e.jqueryEventObject
                //                };
                //                extraParam.data.parentAccordion = parentAccordion;
                //                const { action } = e.data.extraValues;
                //                parentAccordion.Trigger(Accordion.EventNames.OptionClicked, extraParam);
                //                CS.Analytics.Event('Accordion', 'OptionClicked', me.title);
                //                let callUrlOnClick = action != null;
                //                if (callUrlOnClick) {
                //                    let url = e.data.extraValues.url + me.Data.ExtraQueryString;
                //                    if (url) {
                //                        CS.Ajax.Post(url, parentAccordion.getStringifiedData(false), function (response) {
                //                            parentAccordion.Trigger(Accordion.EventNames.OptionClicked, response);
                //                            CS.Analytics.Event('Accordion', 'OptionClicked', me.title);
                //                        });
                //                    }
                //                    if (action == "pin") {
                //                        console.log(`%c me.title = ${me.title}`, `color: #bada55`);
                //                        console.log(`%c parentAccordion.title = ${parentAccordion.title}`, `color: #bada55`);
                //                        CS.Analytics.Event("Pin", parentAccordion.title, `${CommonData.Current.Navigation.Controller}/${CommonData.Current.Navigation.Action}`);
                //                    }
                //                }
                //            }
                //        });
                //        //$options.offon('click.dropdownoptions', function (e) {
                //        //    e.stopImmediatePropagation();
                //        //    dropDown.GetAndShow(me.Data.AccordionDropDownOptions.ShowSectionDropdownOptionsUrl, me.getStringifiedData(true), me.optionsPicker);
                //        //});
                //    }
                //}
            }
            pinSection(pinUrl, accordion, callback) {
                var _a;
                CS.Ajax.Post(pinUrl + ((_a = this.Data) === null || _a === void 0 ? void 0 : _a.ExtraQueryString), accordion.getStringifiedData(false), (response) => {
                    CS.Analytics.Event("Pin", accordion.title, `${CS.CommonData.Current.Navigation.Controller}/${CS.CommonData.Current.Navigation.Action}`);
                    if (callback)
                        callback.call(this);
                });
            }
            //public RefreshItemsCount(newcount: number) {
            //    if (this.$itemsCount == null || this.$itemsCount.lenght == 0) {
            //        return;
            //    }
            //    let me = this;
            //    me.Data.ItemsCount = newcount;
            //    CS.Lag("refresh-items-count-" + me.ControlId, 100, function () {
            //        me.$itemsCount[0].innerHTML = "(" + newcount + ")";
            //    });
            //}
            refreshNoContentMessageVisibility() {
                if (this.Data && this.Data.NoContentMessage) {
                    let $content = this.$Content.find(".horizontal-scroller-content");
                    if ($content.length == 0) {
                        $content = this.$Content;
                    }
                    $content.find(".no-content-message").remove();
                    let anyNode = $content.children().filter(":not(script)");
                    if (anyNode.length == 0) {
                        $content.append("<p class='no-content-message'>" +
                            this.Data.NoContentMessage +
                            "</p>");
                    }
                }
            }
            wrapHeaderContent() {
                if (!this.$Header.hasClass("main-wall-section-header")) {
                    // Le UI des headers des main-wall-sections a été mis à jour, on ne veut pas le wrapper inutilement dans une div.
                    // Mais on wrap quand même si c'est pas une main-wall-section pour préserver les styles des autres accordéons.
                    this.$Header.wrapInner("<div class='inner-content'></div>");
                }
            }
            disposeChilds() {
                CS.DOM.DisposeChilds(this.$Content);
            }
            getStringifiedData(includeSectionsOrder = false) {
                this.Data.LazyLoading = false;
                this.Data.LazyLoadingStartIndex = null;
                return {
                    stringifiedData: JSON.stringify(this.Data),
                    sectionsOrder: includeSectionsOrder
                        ? this.GetCurrentSectionsOrder()
                        : "",
                };
            }
            getLazyStringifiedData(skipQuantity) {
                this.Data.LazyLoading = true;
                this.Data.LazyLoadingStartIndex = skipQuantity;
                return {
                    stringifiedData: JSON.stringify(this.Data),
                };
            }
            GetCurrentSectionsOrder() {
                let $sections = CS.DOM.$sectionMiddle.find(".accordion-container");
                let sectionsOrder = "";
                $.each($sections, (i, element) => {
                    var _a;
                    let $section = $(element);
                    if ($section.parent(".accordion-container").length == 0 &&
                        !$section.hasClass("is-child")) {
                        let accordion = CS.Controls.GetInstance(CS.Controls.Accordion, $section);
                        sectionsOrder +=
                            accordion.Data.Identifier +
                                ":" +
                                ((_a = accordion.Data.PinnedSectionId) !== null && _a !== void 0 ? _a : "-1");
                        sectionsOrder += ";";
                    }
                });
                return sectionsOrder;
            }
        }
        Controls.Accordion = Accordion;
        (function (Accordion) {
            class Events {
                static ExpandedCollapsed(param) {
                    Controls.RegisterEvent(Accordion, EventNames.ExpandedCollapsed, param);
                }
                static ExpandingCollapsing(param) {
                    Controls.RegisterEvent(Accordion, EventNames.ExpandingCollapsing, param);
                }
                static ContentRefreshed(param) {
                    Controls.RegisterEvent(Accordion, EventNames.ContentRefreshed, param);
                }
                static ContentLoaded(param) {
                    Controls.RegisterEvent(Accordion, EventNames.ContentLoaded, param);
                }
                static Ready(param) {
                    Controls.RegisterEvent(Accordion, EventNames.Ready, param);
                }
                static Rendered(param) {
                    Controls.RegisterEvent(Accordion, EventNames.Rendered, param);
                }
                static OptionClicked(param) {
                    Controls.RegisterEvent(Accordion, EventNames.OptionClicked, param);
                }
                static Resized(param) {
                    Controls.RegisterEvent(Accordion, EventNames.Resized, param);
                }
            }
            Accordion.Events = Events;
            class EventNames {
            }
            EventNames.Ready = "accordion-ready";
            EventNames.Rendered = "accordion-rendered";
            EventNames.ExpandedCollapsed = "accordion-expanded-collapsed";
            EventNames.ExpandingCollapsing = "accordion-expanding-collapsing";
            EventNames.ContentRefreshed = "accordion-content-refreshed";
            EventNames.ContentLoaded = "accordion-content-loaded"; //occurs on first load and lazy loading
            EventNames.OptionClicked = "accordion-option-clicked";
            EventNames.Resized = "accordion-resized";
            Accordion.EventNames = EventNames;
        })(Accordion = Controls.Accordion || (Controls.Accordion = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=accordion.js.map
